import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";

export function StatCard({ label, value, delta, suffix, testId }) {
    const diff = typeof delta === "number" ? delta : null;
    const up = diff !== null && diff > 0;
    const down = diff !== null && diff < 0;
    return (
        <div className="rounded-lg border border-line bg-card p-5 shadow-soft" data-testid={testId}>
            <p className="text-[14px] text-subtle">{label}</p>
            <p className="tnum mt-2 text-[32px] font-bold leading-none tracking-tight text-ink">
                {value}
                {suffix && <span className="ml-1 text-[16px] font-medium text-subtle">{suffix}</span>}
            </p>
            {diff !== null && (
                <div className="mt-3 flex items-center gap-1 text-[13px]">
                    <span
                        className={`inline-flex items-center gap-0.5 font-medium ${
                            up ? "text-terracotta" : down ? "text-destructive" : "text-subtle"
                        }`}
                    >
                        {up ? <ArrowUpRight size={14} /> : down ? <ArrowDownRight size={14} /> : <Minus size={14} />}
                        {up ? "+" : ""}
                        {diff}
                    </span>
                    <span className="text-subtle">frente al mes anterior</span>
                </div>
            )}
        </div>
    );
}
